import { bindToKeys } from '../shared/keyboard';
import { KEY_ESC, KEY_LEFT, KEY_RIGHT } from '../shared/keyboard/constants';
import { SELECTORS } from './constants';
import { PhotoCardSliderUI } from './ui';

export class PhotoCardSliderHandler {
  constructor(photos, dataRenderer) {
    this.sliderUI = new PhotoCardSliderUI(dataRenderer);
    this.photos = photos;
    this.currentSlide = 0;
    this.totalPhotos = this.photos.length;

    this.boundPrevKeyHandler = bindToKeys(this.handlePrevSlide, [KEY_LEFT]);
    this.boundNextKeyHandler = bindToKeys(this.handleNextSlide, [KEY_RIGHT]);
    this.boundEscKeyHandler = bindToKeys(this.handleClose, [KEY_ESC]);

    window.addEventListener('resize', this.initUI);
  }

  setCurrentSlide = (index) => {
    this.currentSlide = index;
  };

  handlePrevSlide = () => {
    this.handleChangeSlide(-1);
  };

  handleNextSlide = () => {
    this.handleChangeSlide(1);
  };

  handleClose = () => {
    this.sliderUI.close();
    this.removeSliderHandlers();

    document.removeEventListener('keyup', this.boundEscKeyHandler);
  };

  handleModalClick = ({ target: { classList }}) => {
    if ([...classList].includes(SELECTORS.OVERLAY)) {
      this.handleClose();
    }
  };

  addSliderHandlers = () => {
    this.sliderUI.prevButton.addEventListener('click', this.handlePrevSlide);
    this.sliderUI.nextButton.addEventListener('click', this.handleNextSlide);

    document.addEventListener('keyup', this.boundPrevKeyHandler);
    document.addEventListener('keyup', this.boundNextKeyHandler);
  };

  removeSliderHandlers = () => {
    document.removeEventListener('keyup', this.boundPrevKeyHandler);
    document.removeEventListener('keyup', this.boundNextKeyHandler);
  };

  addCardHandlers = () => {
    this.sliderUI.closeButton.addEventListener('click', this.handleClose);
    this.sliderUI.modal.addEventListener('click', this.handleModalClick);

    document.addEventListener('keyup', this.boundEscKeyHandler);
  };

  handleOpenSlider = (index) => {
    this.setCurrentSlide(index);
    this.sliderUI.updateImage(this.photos[this.currentSlide]);
    this.sliderUI.updateContent();
    this.addCardHandlers();

    if (this.totalPhotos === 1) {
      this.sliderUI.hideControllers();
    } else {
      this.sliderUI.showControllers();
      this.addSliderHandlers();
    }

    this.sliderUI.open();
  };

  handleChangeSlide = (direction) => {
    const newIndex = (this.currentSlide + direction + this.totalPhotos) % this.totalPhotos;

    this.setCurrentSlide(newIndex >= 0 ? newIndex : this.totalPhotos - 1);
    this.sliderUI.updateImage(this.photos[this.currentSlide]);
  };

  initUI = () => {
    this.sliderUI.create(this.photos, this.handleOpenSlider);
  };
}
